import { apiClient } from "@/lib/api/client";
import { apiPaths } from "@/lib/api/paths";
import type { ExportRegistersResponse } from "./type";
import type { RegistersFilters } from "../list/type";
import { isEmpty } from "@utils/formatters";

export async function exportRegisters(
  query?: RegistersFilters,
): Promise<ExportRegistersResponse> {
  const params = new URLSearchParams();

  if (query) {
    Object.entries(query).forEach(([key, value]) => {
      if (isEmpty(value)) return;

      params.append(key, String(value));
    });
  }

  let url = apiPaths.registers.export;
  if (params.toString()) {
    url += `?${params.toString()}`;
  }

  const response = await apiClient.get<ExportRegistersResponse>(url);

  return response.data;
}
